'use strict';

angular.module('atex.dam').controller('DamRelationsController', ['$scope', '$rootScope', '$state', '$stateParams', 'DamService', 'ContentService','$window', '$timeout',
function($scope, $rootScope, $state, $stateParams, DamService, ContentService, $window, $timeout) {
  
  var currentLineHeightThumbList = 120;
  $scope.entries  = [];
  $scope.selected  = [];
  $scope.querying = true;
  $scope.toggle='col-lg-7';
  
  $scope.id = $stateParams.id; 
    
  $scope.back = function() {
    if ($rootScope.entryToaddInlistAfterDuplication){
      // Notify the list to focus on new duplicated element
      $timeout(function() {
        $rootScope.$broadcast('dam:selectNewDuplicatedItem');
      },1000);
    }
    $window.history.back();
  };
  
  $scope.clearSelection = function() {
    $scope.selected.length = 0;
  };
  
  var showRelationsInList = function(entries,localArray) {
    var currentLen = 0;
    var respLen = entries.length;
    
    entries.forEach(function(entry, index) {
      var transferInfo = {
        id : entry.id ? entry.id : entry
      };
      ContentService.getContent(transferInfo).then(function(response) {
        response._data = response.data;
        localArray[index+1] = response;
        currentLen++;
        if (currentLen === respLen) {
          setEntries(localArray);
        }
      }).then(null, function(error) {
        localArray[index+1] = undefined;
        currentLen++;
        if (currentLen === respLen) {
          setEntries(localArray);
        }
      });
    });
  };
  
  var setEntries = function(entries) {
    var newEntries = [];
    entries.forEach(function(entry) {
      if (entry) {
        newEntries.push(entry);
      }
    });
    newEntries.forEach(function(entry, index) {
      entry._data = entry.data;
      entry._data.id = entry.id;
    });
    var data = {};
    data.response = {};
    data.response.docs = newEntries;
    data.response.start = 0;
    data.response.numFound = newEntries.length;
    addEntries(data);
    $scope.querying = false;
  };
  
  function addEntries(searchResponse) {
    var documents = searchResponse.response.docs;
    if (searchResponse.response.numFound <= 0) {
      $scope.entries.length = 0;
    }
    if (!documents) {
      return;
    }
    var newEntries = [];
    documents.forEach(function(document) {
      atex.dam.AngularUtils.fixUrls(document._data);
      // Check width and depth
      atex.dam.AngularUtils.fixWidthHeight(document, currentLineHeightThumbList);
      $scope.entries.push(document);
    });
  }
  
  var transferInfo = {
    id : $scope.id
  }; 
  
  ContentService.getContent(transferInfo).then(function(response) {
    var localArray = [];
	
	response._data = response.data;
    localArray.push(response);
	
	var references = [];
    if(	response.data.aspects.contentData.data.resources !== undefined ) {
	  response.data.aspects.contentData.data.resources.forEach(function(resource) {
        var tmp = {
          id : atex.dam.AngularUtils.removePrefix(resource) 	 	 
        };
      
        references.push(tmp);
      });
    }
    
    if(	response.data.aspects.contentData.data.images !== undefined ) {
  	  response.data.aspects.contentData.data.images.forEach(function(resource) {
        var tmp = {
          id : atex.dam.AngularUtils.removePrefix(resource) 	 	 
        };
        
        references.push(tmp);
      });
    }
    
    showRelationsInList(references,localArray);
  }).then(null, function(error) {
    console.log('ERROR: loadReferences error:', error);
    $scope.querying = false;
  });
}]);

